import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { formatDateDDMMYYYY, formatTimeWAT } from "@/lib/format";

export const PortalSchedule = () => {
  const [shifts, setShifts] = useState([]);
  const [sites, setSites] = useState([]);
  const [guards, setGuards] = useState([]);

  const load = useCallback(async () => {
    const [sh, st, g] = await Promise.all([
      api.get("/shifts"),
      api.get("/sites"),
      api.get("/guards"),
    ]);
    setShifts(sh.data);
    setSites(st.data);
    setGuards(g.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const siteName = (id) => sites.find(s => s.id === id)?.name || "—";
  const guardName = (id) => guards.find(g => g.id === id)?.full_name || "—";

  return (
    <div className="s-card-light" style={{ padding: 0 }}>
      <table className="s-table s-table-light">
        <thead><tr><th>Date</th><th>Site</th><th>Guard</th><th>Start</th><th>End</th><th>Status</th></tr></thead>
        <tbody>
          {shifts.map(s => (
            <tr key={s.id}>
              <td className="mono">{formatDateDDMMYYYY(s.start_at)}</td>
              <td>{siteName(s.site_id)}</td>
              <td>{guardName(s.guard_id)}</td>
              <td className="mono">{formatTimeWAT(s.start_at)}</td>
              <td className="mono">{formatTimeWAT(s.end_at)}</td>
              <td>{s.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
